import { Component, Input, NgZone } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService, NotificationsService,
    PriceService,
    CommonTicketItem,
    TeamEvent,
    Package
} from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { PopoverController, ToastController, NavParams, ViewController } from 'ionic-angular';
import { SafeHtml } from '@angular/platform-browser';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the DisplayMessageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'custom-forms',
    templateUrl: 'custom-forms.html'
})
export class CustomFormsComponent extends BaseComponent {
    purchasedItems: TeamEvent[] | Package[];
    hasPackages: boolean;
    tickets: CommonTicketItem[];
    displayItemInfo: boolean = false;
    orderCustomForms: {
        FormData: string,
        HTML: string,
        HTML_Sanitized?: SafeHtml;
        ID: number
    }[] = [];

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected viewCtrl: ViewController,
        protected navParams: NavParams,
        protected ngZone: NgZone,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "CustomFormsComponent"
        );
    }

    ngOnInit() {
        this.purchasedItems = this.navParams.get('purchasedItems');
        this.hasPackages = this.navParams.get('hasPackages') as boolean;
        this.tickets = this.navParams.get('tickets') as CommonTicketItem[];
        this.displayItemInfo = this.navParams.get('displayItemInfo') as boolean;
        this.orderCustomForms = this.navParams.get('orderCustomForms') || [];

        for (let item of this.purchasedItems) {
            (item as any).filteredTickets = this.filterTickets(this.tickets, item);
        }
    }

    createRange(number) {
        if (!number) {
            return [0];
        }
        var items: number[] = [];
        for (var i = 1; i <= number; i++) {
            items.push(i);
        }
        return items;
    }

    filterTickets(tickets: CommonTicketItem[], purchasedItem: any) {
        if (this.hasPackages) {
            return tickets.filter(t => t.SeasonPassID == purchasedItem.SeasonPassID &&
                (t.CustomForms as { HTML: string, HTML_Sanitized: SafeHtml }[][]).some(p => p.some(x => !!x.HTML)));
        } else {
            return tickets.filter(t => t.EventID == purchasedItem.EventID &&
                (t.CustomForms as { HTML: string, HTML_Sanitized: SafeHtml }[]).some(p => !!p.HTML));
        }
    }

    continueClicked() {
        if (this.validateForms()) {
            let validatedForms = this.ngZone.runOutsideAngular(() => {
                let result: {
                    formId: string;
                    ticketId: string;
                    formSerialized: string;
                }[] = [];

                const $ = (window as any).jQuery;
                if ($) {
                    $(".custom-forms .ticket-form").each(function () {
                        const $this = $(this);
                        const serialized = $(this).serialize();
                        const formId = $this.attr('data-form-id');
                        const ticketId = $this.attr('data-ticket-id');

                        result.push({
                            formId: formId,
                            ticketId: ticketId,
                            formSerialized: serialized
                        });
                    });
                }
                
                return result;
            });

            let orderForms = this.ngZone.runOutsideAngular(() => {
                let result: {
                    formId: string;
                    formSerialized: string;
                }[] = [];

                const $ = (window as any).jQuery;
                if ($) {
                    $(".order-forms .order-form").each(function () {
                        const $this = $(this);
                        const serialized = $(this).serialize();
                        const formId = $this.attr('data-form-id');

                        result.push({
                            formId: formId,
                            formSerialized: serialized
                        });
                    });
                }

                return result;
            });

            this.viewCtrl.dismiss(
                {
                    action: 'continue',
                    tickets: this.tickets,
                    forms: validatedForms,
                    orderForms: orderForms
                }
            );
        } else {
            this.showNotification("You need to fill in all the required fields !", undefined, undefined, 'error');
        }
    }

    validateForms(): boolean {
        return this.ngZone.runOutsideAngular(() => {
            const $ = (window as any).jQuery;
            if ($) {
                var invalidFields = $.grep($('.required'), function (n, i) {
                    let type = $(n).attr('type'),
                        valid = false;
                    switch (type) {
                        case 'text':
                            valid = $(n).val() === "";
                            break;
                        case 'checkbox':
                            valid = !$(n).is(":checked");
                    }
                    return valid;
                });

                if (invalidFields && invalidFields.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }

            return true;
        });
    }

    cancelClicked() {
        this.viewCtrl.dismiss(
            'cancel'
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/custom-forms/custom-forms.ts